import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() { }

  // === TOKEN ===
  public set token(token: string) {
    localStorage.setItem('token', JSON.stringify(token));
    const expiresAt = new Date().getTime() + 60 * 60 * 1000; // 60 minutos
    localStorage.setItem('sessionExpiration', JSON.stringify(expiresAt));
  }

  public get token(): string | null {
    const token = localStorage.getItem('token');
    return token ? JSON.parse(token) : null;
  }

  // === PERMISSIONS ===
  public set permissions(permissions: number[]) {
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }

  public get permissions(): number[] | null {
    const permissions = localStorage.getItem('permissions');
    return permissions ? JSON.parse(permissions) : null;
  }

  // === DOCUMENTO DEL USUARIO ===
  public set documentNumber(documentNumber: string) {
    localStorage.setItem('documentNumber', JSON.stringify(documentNumber));
  }

  public get documentNumber(): string | null {
    const value = localStorage.getItem('documentNumber');
    return value ? JSON.parse(value) : null;
  }

  // === REFRESH TOKEN ===
  public set refreshToken(token: string) {
    localStorage.setItem('refresh_token', JSON.stringify(token));
  }

  public get refreshToken(): string | null {
    const token = localStorage.getItem('refresh_token');
    return token ? JSON.parse(token) : null;
  }

  // === EXPIRACIÓN DE SESIÓN ===
  public get isSessionExpired(): boolean {
    const expiration = localStorage.getItem('sessionExpiration');
    if (!expiration) return true;

    const now = new Date().getTime();
    return now > JSON.parse(expiration);
  }

  // === LOGIN CHECK ===
  public get isLoggedIn(): boolean {
    return !!this.token && !this.isSessionExpired;
  }

  // === LOGOUT ===
  public logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
    localStorage.removeItem('documentNumber');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('sessionExpiration');
  }
}
